import './FormInput.css';

import { useAutoFocus } from '@ipfabric/ui-components/hooks/useAutoFocus';
import classNames from 'classnames';
import type { FC } from 'react';
import type { InputHTMLAttributes, ReactNode } from 'react';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  children: ReactNode;
  hasError?: boolean;
  spaceTop?: number;
  spaceRight?: number;
}

export const FormInput: FC<Props> = ({
  autoComplete,
  autoFocus,
  children,
  className,
  hasError,
  spaceTop,
  spaceRight,
  style,
  ...otherInputProps
}) => {
  const inputRef = useAutoFocus(autoFocus);

  return (
    <input
      {...otherInputProps}
      autoComplete={
        autoComplete ??
        (otherInputProps.type === 'password' ? 'off' : autoComplete)
      }
      className={classNames(
        'form-input',
        hasError && 'form-input--error',
        className,
      )}
      style={{
        ...style,
        marginRight: spaceRight ?? 0,
        marginTop: spaceTop ?? 0,
      }}
      ref={inputRef}
    />
  );
};
